/* eslint-disable */
const RENDERING_QUEUE_STATE = {
	selectedReports: [],
	renderingQueueReports: [],
	refreshRenderingQueue: false
};
export default RENDERING_QUEUE_STATE;
